
<template>

  <div class="modal fade" id="splashScreenModal">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Splash Screen</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Splash Screen Title</label>
                      <input type="text" name="title" required v-model="splashScreen.title"
                             :class="{ 'form-control': true }" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="input-blocks">
                        <label>Start Date</label>

                        <input type="date" :class="{ 'form-control': true }" v-model="splashScreen.start_date"/>

                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="input-blocks">
                        <label>End Date</label>
                        <input type="date" :class="{ 'form-control': true }" v-model="splashScreen.end_date"/>

                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <!--                      <label>Description</label>-->

                      <div class="d-flex my-2">
                        <a-image :width="0" :style="{ display: 'none' }" :preview="{
              visible,
              onVisibleChange: setVisible,
            }" :src="imagePreviewUrl"/>

                        <div v-if="imagePreviewUrl" class="image-container col-12 rounded" @mouseover="showOverlay = true"
                             @mouseleave="showOverlay = false">
                          <img :src="imagePreviewUrl" alt="Preview"/>
                          <div v-if="showOverlay" class="overlay">
                            <button @click="deleteImage" class="delete-btn">
                              <vue-feather type="trash-2"></vue-feather>
                            </button>
                            <button @click="openThumbnail(imagePreviewUrl)" class="zoom-btn" type="button">
                              <vue-feather type="zoom-in"></vue-feather>
                            </button>
                          </div>
                        </div>

                        <div class="file-upload " v-else>
                          <input type="file" @change="previewImage"/>

                          <span role="img" aria-label="plus" class="anticon anticon-plus">
                <svg focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"
                     viewBox="64 64 896 896">
                  <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                  <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                </svg><!----></span>
                          <div class="file-upload-text">Image</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-submit" id="submit" :disabled="isSubmitDisabled">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>

import {useSplashScreenStore} from "@/store/splashScreenStore";
import { checkInputValidity } from '@/utils/validator';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';

const splashScreenStore = useSplashScreenStore();

const showOverlay = ref(false);

const visible = ref(false);

const formTouched = ref(false);


const setVisible = (value) => {
  visible.value = value;
};
const imagePreviewUrl = ref("");

const props = defineProps({
  splashScreenId: null
});
// data
const splashScreen = ref({
  title: '',
  start_date: '',
  end_date: '',
  image: null
});

const isSubmitDisabled = computed(() => {
  return !splashScreen.value.title || splashScreen.value.title.trim() === "" || !splashScreen.value.image;
});

function previewImage(event) {
  const file = event.target.files[0];
  if (file) {
    splashScreen.value.image = file;
    log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      imagePreviewUrl.value = reader.result;
    };
  }
}

function deleteImage() {
  imagePreviewUrl.value = "";
  splashScreen.value.image = null;
}

function openThumbnail(image) {
  imagePreviewUrl.value = image;
  setVisible(true);
}

async function submitForm() {

  const valid = checkInputValidity("submit");
  if (!valid) return;

  if (props.splashScreenId) {
    // update
    await splashScreenStore.updateSplashScreen(props.splashScreenId, splashScreen.value);
  } else {
    // add
    await splashScreenStore.addSplashScreen(splashScreen.value);
  }

  resetForm();
  $("#splashScreenModal").modal("hide");
}

watch(() => props.splashScreenId, () => {
  if (props.splashScreenId) {
    splashScreen.value = splashScreenStore.splashScreen.find(m => m.id === props.splashScreenId);
    // splashScreen.value = found ? cloneDeep(found) : { title: '', description: '', file: null };
    imagePreviewUrl.value = splashScreen.value.image || '';
  } else {
    splashScreen.value = { title: '', start_date: '', end_date: '', image: null };
    imagePreviewUrl.value = '';
  }
}, { immediate: true });

const resetForm = () => {
  splashScreen.value = {
    title: '',
    start_date: '',
    end_date: '',
    image: null
  };

  imagePreviewUrl.value = '';
  formTouched.value = false;
};

onMounted(() => {
  const modalEl = document.getElementById("splashScreenModal");

  // modalEl.addEventListener("hidden.bs.modal", () => {
  //   resetForm();
  // });
});


</script>

<style scoped>

</style>